import { CONTACT, INDUSTRIES } from "@/data/site";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-surface" data-testid="footer">
      <div className="container-x py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="font-display text-2xl font-black uppercase tracking-tight">
              Agraj<span className="text-primary">.</span> Enterprise
            </span>
            <p className="mt-4 max-w-sm text-sm text-muted-foreground leading-relaxed">
              Industrial painting & protective coating solutions. Protecting structures, enhancing performance and
              extending asset life since 2018.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-sm font-bold uppercase tracking-wider">Services</h4>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {[
                "Structural Painting",
                "Industrial Coating",
                "Corrosion Protection",
                "Factory Painting",
                "Interior Painting",
                "Exterior Painting",
                "Retrofitting",
                "Non Destructive Testing (NDT)",
                "Vibration Control",
              ].map((title) => (
                <li key={title}>
                  <a href="#services" className="text-sm text-muted-foreground transition-colors hover:text-primary">
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-display text-sm font-bold uppercase tracking-wider">Contact</h4>
            <ul className="mt-4 space-y-4 text-sm text-muted-foreground">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-primary" />
                <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-primary">{CONTACT.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-primary" />
                <a href={`mailto:${CONTACT.email}`} className="break-all hover:text-primary">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <span>{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-center text-xs text-muted-foreground sm:flex-row sm:text-left">
          <p>© {year} Agraj Enterprise. All rights reserved.</p>
          <p>{INDUSTRIES.length}+ industrial sectors served · Built for durability.</p>
        </div>
      </div>
    </footer>
  );
}
